import { Link } from "react-router-dom";
import { MapPin, Phone, Instagram, Clock } from "lucide-react";
import { CATEGORIES } from "@/data/catalog";

const Footer = () => (
  <footer className="border-t border-white/10 bg-ink-2">
    <div className="grid h-1.5 grid-cols-4">
      <div className="bg-brand-cyan" />
      <div className="bg-brand-magenta" />
      <div className="bg-brand-yellow" />
      <div className="bg-white" />
    </div>
    <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
      <div>
        <img
          src="/assets/logo-dark.png"
          alt="TLF DESIGNZ — Print • Brand • Create"
          className="h-14 w-auto"
          data-testid="footer-brand-logo"
        />
        <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-400">
          Industrial-grade custom printing, apparel and branding. Print loud. Ship fast.
        </p>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-widest text-zinc-600">
          300 DPI • CMYK Calibrated • Vector 2400
        </p>
      </div>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Shop</p>
        <ul className="mt-4 space-y-2">
          {CATEGORIES.map((c) => (
            <li key={c.slug}>
              <Link
                to={`/shop/${c.slug}`}
                data-testid={`footer-link-${c.slug}`}
                className="text-sm text-zinc-400 transition-colors hover:text-brand-cyan"
              >
                {c.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Builders</p>
        <ul className="mt-4 space-y-2">
          <li>
            <Link to="/configure/stickers-labels" data-testid="footer-link-stickers-builder" className="text-sm text-zinc-400 hover:text-brand-magenta">
              Stickers & Labels Builder
            </Link>
          </li>
          <li>
            <Link to="/configure/snow-globe-tumblers" data-testid="footer-link-tumbler-builder" className="text-sm text-zinc-400 hover:text-brand-cyan">
              Snow Globe Tumbler Builder
            </Link>
          </li>
          <li>
            <Link to="/bulk-inquiry" data-testid="footer-link-bulk" className="text-sm text-zinc-400 hover:text-brand-yellow">
              Quick Order / Bulk Inquiry
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Visit / Contact</p>
        <ul className="mt-4 space-y-4 text-sm">
          <li className="flex gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-magenta" />
            <div>
              <p className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">Pick Up Location</p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=24+Upper+Elleston+Road,+Kingston+16,+Jamaica"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-directions-link"
                className="mt-0.5 inline-block leading-relaxed text-zinc-200 underline decoration-brand-magenta/50 underline-offset-4 transition-colors hover:text-brand-magenta"
              >
                24 Upper Elleston Road,<br />Kingston 16, Jamaica
              </a>
              <p className="mt-0.5 font-mono text-[9px] uppercase tracking-widest text-zinc-600">
                Tap for directions
              </p>
            </div>
          </li>
          <li className="flex gap-3">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-cyan" />
            <div>
              <p className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">Phone</p>
              <a
                href="tel:+18762980309"
                data-testid="footer-phone-link"
                className="mt-0.5 inline-block text-zinc-200 transition-colors hover:text-brand-cyan"
              >
                (876) 298-0309
              </a>
            </div>
          </li>
          <li className="flex gap-3">
            <Instagram className="mt-0.5 h-4 w-4 shrink-0 text-brand-yellow" />
            <div>
              <p className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">Instagram</p>
              <a
                href="https://www.instagram.com/tlfdesignz"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram-link"
                className="mt-0.5 inline-block text-zinc-200 transition-colors hover:text-brand-yellow"
              >
                @tlfdesignz
              </a>
            </div>
          </li>
          <li className="flex gap-3">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-zinc-500" />
            <div>
              <p className="font-mono text-[9px] uppercase tracking-widest text-zinc-500">Hours</p>
              <p className="mt-0.5 text-zinc-400">Mon–Sat • 9AM–7PM</p>
            </div>
          </li>
          <li>
            <Link to="/terms" data-testid="footer-link-terms" className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 transition-colors hover:text-brand-cyan">
              Terms & Cancellation Policy
            </Link>
          </li>
          <li>
            <Link to="/admin" data-testid="footer-link-admin" className="font-mono text-[10px] uppercase tracking-widest text-zinc-600 transition-colors hover:text-brand-yellow">
              Studio Admin
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">
      © 2026 TLF DESIGNZ — Print • Brand • Create
    </div>
  </footer>
);

export default Footer;
